import {CSSProperties, FC} from 'react';


export interface IIconTelegramProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconTelegram: FC<IIconTelegramProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm6.022 7.606c.05-.525-.322-.789-.807-.601L9.563 9.958c-1.005.388-2.012.772-3.013 1.168a1.662 1.662 0 0 0-.477.299c-.15.133-.126.318.041.432.109.074.236.126.361.166.816.26 1.634.516 2.453.766.106.033.156.084.19.188.345 1.08.698 2.157 1.046 3.236.048.148.135.216.29.224a.716.716 0 0 0 .565-.23c.454-.447.912-.89 1.374-1.34.047.033.09.062.13.092l2.566 1.895c.51.377.947.215 1.079-.406.557-2.615 1.111-5.23 1.665-7.846.07-.33.157-.66.19-.996Zm-2.356 1.181c.075-.019.162.014.244.023-.037.067-.06.15-.113.198-.867.788-1.737 1.571-2.606 2.356-.786.708-1.57 1.418-2.359 2.123a.436.436 0 0 0-.155.315c-.048.594-.106 1.187-.16 1.78-.003.024-.01.048-.016.072l-.029.008-.533-1.635c-.134-.41-.263-.82-.404-1.226-.042-.12-.021-.178.087-.246 1.92-1.206 3.838-2.417 5.758-3.626a1.06 1.06 0 0 1 .286-.142Z" clipRule="evenodd" />
        </svg>
    );
};
